import { type TemplateResource } from "@/types/entities/templates";
import { formatToRelativeTime } from "@/utils/dates";
import {
  Avatar,
  AvatarFallback,
  Badge,
  Icon,
} from "@elaniintc/goes-design-system";
import dayjs from "dayjs";
import { getStatusBadgeColor } from "@/utils/templates-ui";
import EllipsisDropdown from "./EllipsisDropdown";

const labelsTranslate = {
  active: "Activa",
  draft: "En Construcción",
  inactive: "Inactiva",
};

export default function DocumentCard({
  template,
  onDuplicate,
  onApproved,
  onSelectEdit,
  onSelectDeactivate,
  onSelectActivate,
}: {
  template: TemplateResource;
  onDuplicate?: (id: string) => void;
  onApproved?: (id: string) => void;
  onSelectEdit?: (template: TemplateResource) => void;
  onSelectDeactivate: () => void;
  onSelectActivate: () => void;
}) {
  return (
    <div className="w-full flex items-center gap-4 bg-neutral-object border-[0.5px] border-neutral min-h-[68px] rounded-xl p-3 shadow-neutral-xs cursor-pointer transition-shadow hover:shadow-neutral-md">
      <Avatar shape="square" size="lg">
        <AvatarFallback color={"action"} type="icon" shape="square">
          <Icon type="fas" name="files" />
        </AvatarFallback>
      </Avatar>
      <div className="flex-1 min-w-0 flex flex-col justify-center">
        <div className="flex items-center gap-2">
          <p className="font-normal text-base font-geist text-body-loud truncate leading-tight">
            {template.display_name || ""}
          </p>
        </div>

        <span className="text-body-quiet font-geist text-xs font-normal leading-snug mt-0.5">
          Última actualización{" "}
          {formatToRelativeTime(template?.updated_at || "")} | Creado el{" "}
          {dayjs(template?.created_at || new Date()).format("DD MMMM, YYYY")}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Badge size="sm" variant={getStatusBadgeColor(template.status)}>
          {labelsTranslate[template.status as keyof typeof labelsTranslate]}
        </Badge>
        <EllipsisDropdown
          entity="template"
          id={template.id}
          onDuplicate={onDuplicate}
          onSelect={() => onSelectEdit?.(template)}
          onApproved={onApproved}
          status={template.status}
          vacio={template.rich_text === null}
          onDeactivate={onSelectDeactivate}
          onActivate={onSelectActivate}
        />
      </div>
    </div>
  );
}
